import DynamicBiIcon from "./DynamicBiIcon";
import { CheckSkeleton } from "../utils/checkSkeleton";
import { useLocation, useParams, Link } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import {
  actualUIState,
  setActiveTab,
} from "../../SharedModule/redux/reducers/uiShared.reducer";
import { LeftNavBarLink } from "../../TimesModule/types/times-module-types";
import { verifyModuleAccess } from "../utils/accessUtils";
import { selectUserRoles } from "../redux/reducers/auth.reducer";
import { ExternalLink } from "./ExternalLink";

// IMPORTANT: role SHOULD BE a string array!!! If you want to use a policy ve careful because it's already a string array.
export const LeftNavBarSection = ({
  mainTitle,
  biIconName,
  listOfLinks,
  requireModuleAccess,
  roleRequired,
  actualUserRoles = [],
}: any) => {
  let { productId }: any = useParams();

  const url = process.env.REACT_APP_ASUITE_BASE_URI;

  const location: any = useLocation();

  const { activeTab, isLoadingRolesProductsModule } =
    useSelector(actualUIState);
  // TODO: once products roles are coming in shared roles endpoint, use only "rolesLoaded" flag
  const { rolesLoaded } = useSelector(selectUserRoles);

  const dispatch = useDispatch();

  if (!activeTab) {
    dispatch(
      setActiveTab(
        "/" +
          location.pathname.substring(location.pathname.lastIndexOf("/") + 1)
      )
    );
  }

  return (
    <>
      {verifyModuleAccess(
        requireModuleAccess,
        roleRequired,
        actualUserRoles
      ) && (
        <li className="link-title" key={biIconName}>
          <CheckSkeleton
            isLoading={isLoadingRolesProductsModule || !rolesLoaded}
            style={{ width: "25px", marginRight: "10px", height: "20px" }}
          >
            <DynamicBiIcon icon={biIconName} className="link-title-icon my-2" />
          </CheckSkeleton>
          <CheckSkeleton
            isLoading={isLoadingRolesProductsModule || !rolesLoaded}
            style={{ width: "80px", height: "20px" }}
          >
            <span className="link-title-text my-2">{mainTitle}</span>
          </CheckSkeleton>
        </li>
      )}
      {listOfLinks.map((link: LeftNavBarLink) => (
        <>
          {verifyModuleAccess(
            link.requireModuleAccess,
            link.roleRequired,
            actualUserRoles
          ) && (
            <CheckSkeleton
              isLoading={isLoadingRolesProductsModule || !rolesLoaded}
              key={link.text}
              style={{
                width: "175px",
                margin: "5px 10px 5px 26px",
                height: "25px",
              }}
            >
              <li
                key={link.text}
                className={`hoverable ${
                  activeTab === link.route ? "active" : ""
                }`}
              >
                {link.newTab && (
                  <ExternalLink
                    to={link.route}
                    onClick={link.onClick}
                    className={`${link.text.length > 21 ? "multiline" : ""}`}
                  >
                    <span>{link.text}</span>
                  </ExternalLink>
                )}
                {!link.newTab && !link.asuiteLink && (
                  <Link
                    to={link.route.replace(":productId", productId)}
                    onClick={link.onClick}
                    className={`${link.text.length > 21 ? "multiline" : ""}`}
                  >
                    <span>{link.text}</span>
                  </Link>
                )}
                {!link.newTab && link.asuiteLink && (
                  <Link
                    to={`${url}${link.route}`}
                    onClick={link.onClick}
                    className={`text-decoration-none ${
                      link.text.length > 17 ? "multiline" : ""
                    }`}
                  >
                    <span>{link.text}</span>
                  </Link>
                )}
              </li>
            </CheckSkeleton>
          )}
        </>
      ))}
    </>
  );
};
